import React, { useEffect } from 'react';

import TermsAndConditions from './TermsAndConditions';

import { RX } from './../../constants';

import { getLogoutUrl } from './../../util/helpers';

const initComponent = (flex = window.flex) => {
    function withTermsAndConditions({ termsAndConditions = {}, children }) {
        const checkedDealers = sessionStorage.getItem('terms-and-conditions:checked-dealers');
        const { isLoading, invalidDealers = [], tcContentUrl } = termsAndConditions;

        useEffect(() => {
            flex.trigger(RX.TERMS_AND_CONDITIONS.CLEAR_BRANCH);
            if (!checkedDealers) {
                flex.trigger(RX.TERMS_AND_CONDITIONS.GET_DEALERS_INFO);
            }
        }, []);

        function onDeclineClick() {
            const logoutUrl = getLogoutUrl(flex);

            flex.redirect(logoutUrl);
        }

        function onAcceptClick() {
            flex.trigger(RX.TERMS_AND_CONDITIONS.ACCEPT_DEALERS, invalidDealers);
        }

        if (checkedDealers) {
            return children;
        }

        if (isLoading) {
            return flex.components.loader;
        }

        if (invalidDealers.length) {
            return (
                <TermsAndConditions
                    invalidDealers={invalidDealers}
                    tcContentUrl={tcContentUrl}
                    onDeclineClick={onDeclineClick}
                    onAcceptClick={onAcceptClick}
                />
            );
        }

        return null;
    }
    return withTermsAndConditions;
};

module.exports = initComponent;
